<template>
  <ScNavigationItem
    :key="item.id"
    :title="item.fields.title"
    :link="item.fields.link"
    class="nav-item"
  >
    <template #subMenu>
      <div
        v-if="!!subItems"
        class="submenu-container"
        :class="{inverted: inverted}"
      >
        <ul class="submenu" role="list">
          <ScNavigationItem
            v-for="subMenuItem in subItems"
            :key="subMenuItem.id"
            :link="subMenuItem.fields.link"
            class="submenu-item"
          />
        </ul>
      </div>
    </template>
  </ScNavigationItem>
</template>


<script>
import ScNavigationItem from '../../sc-navigation-item'

export default {
  components: {
    ScNavigationItem
  },
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    inverted: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    subItems () {
      return this.item.fields.items
    }
  }
}
</script>

<style lang="scss" scoped>

.nav-item {
  display: flex;
  align-items: center;
  @include font('060');

  .submenu-container {
    display: none;
    position: absolute;
    background-color: $color-white;
    top: calc(100% - #{$space-060});
    left: 0;
    right: 0;
    z-index: 3;
    padding: $space-100 0 $space-070;

    &.inverted {
      background-color: $color-black;
    }
  }

  &.open-submenu {
    .submenu-container {
      display: block;
    }
  }
}

.submenu {
  padding-inline-start: 0;

  .submenu-item {
    padding-bottom: $space-050;
  }
}
</style>
